import { useTheme } from '@emotion/react';
import Button from '@components/Button';
import styled from '@emotion/styled';
import { isMobile } from 'react-device-detect';

const Container = styled.div(({ theme, hoverCursor }) => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    userSelect: 'none',
    position: 'relative',
    width: '100%',
    transition: theme.transition.default,
    'button': {
        display: 'none'
    },
    '.btnContainer': {
        display: 'none'
    },
    '&:hover': {
        button: {
            display: 'inline-block'
        },
        '.btnContainer': {
            display: 'block'
        },
        transform: 'scale(1.05)',
        cursor: hoverCursor
    }
}));

const Image = styled.img(({ theme }) => ({
    paddingTop: theme.spacing.xxs,
    height: theme.size.assetWidthTiny,
    maxWidth: '100%',
    objectFit: 'contain',
    [theme.mediaQuery.largeMobileUp]: {
        height: theme.size.assetWidth
    }
}));

const Video = styled.video(({ theme }) => ({
    paddingTop: theme.spacing.xxs,
    height: theme.size.assetWidthTiny,
    maxWidth: '100%',
    objectFit: 'contain',
    [theme.mediaQuery.largeMobileUp]: {
        height: theme.size.assetWidth
    }
}));

const Badge = styled.span(({ theme }) => ({
    color: theme.colors.common.white,
    backgroundColor: theme.colors.secondary.main,
    borderRadius: theme.borderRadius.l,
    width: theme.size.mintWidth,
    height: theme.size.mintHeight,
    textAlign: 'center',
    lineHeight: theme.size.mintHeight
}));

const Caption = styled.p(({ theme }) => ({
    color: theme.colors.common.black,
    marginTop: theme.spacing.xxs,
    zIndex: 10
}));

const ButtonContainer = styled.div(({ theme }) => ({
    position: 'absolute',
    bottom: theme.spacing.xs,
    right: 0,
    left: 0,
    width: isMobile ? '100%' : '',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
}));

function GridItem({ id, mintNumber, srcImg, textColor, srcBackImg, badge, caption, onClick, buttons, templateId, secondary, type = 'image' }) {
    const theme = useTheme();

    const ButtonStyle = {
        marginBottom: theme.spacing.xs,
        width: theme.size.gridItemButtonsWidth,
        display: isMobile ? 'block' : '',
        marginLeft: isMobile ? 'auto' : '',
        marginRight: isMobile ? 'auto' : ''
    };

    const captionStyle = {
        ...theme.typography.h6,
        color: `${textColor}`,
        fontWeight: 'bold',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        width: isMobile ? '50%' : '60%'
    };

    return (
        <Container onClick={() => onClick({ id, mintNumber, type, srcImg, srcBackImg, caption, badge, templateId })}>
            { badge ? <Badge>{badge}</Badge> : null }
            { type === 'video' ?
                <Video muted autoPlay loop playsInline height={theme.size.assetWidth} width='100%'>
                    <source src={srcImg} type="video/mp4" />
                </Video>
                : <Image alt={caption} src={srcImg} />
            }
            { buttons ?
                <>
                    <ButtonContainer>
                        { buttons.map((button, index) => (
                            <Button
                                key={index}
                                style={ButtonStyle}
                                secondary={button.secondary}
                                onClick={(e) => {
                                    if (button.onClick) {
                                        e.stopPropagation();
                                        button.onClick({ id, mintNumber, type, srcImg, srcBackImg, caption, badge, templateId });
                                    }
                                }}
                            >
                                {button.label}
                            </Button>
                        ))}
                    </ButtonContainer>
                </>
                : null
            }
            { caption ? <Caption style={captionStyle}>{caption}</Caption> : null }
        </Container>
    );
}

export default GridItem;
